/* Gaming Patented 8-Speaker Immersive */
(function () {
  "use strict";

  var items = [
    {
      title: "8-Speaker Architecture",
      desc: "Four Dedicated Speakers Per Ear Reveal Layers Traditional Headphones Miss And Deliver Exceptional Detail, Frequency Separation, And Depth Of Sound."
    },
    {
      title: "Natural Immersive Sound Field",
      desc: "Sound Interacts With Your Outer Ear Before Reaching The Eardrum For A More Lifelike Experience And Minimal Listening Fatigue. We Built HEAVYS Tech Around How Humans Naturally Hear Sound."
    },
    {
      title: "Front-Facing Tweeters",
      desc: "Positioned In Front Of The Ear For Improved Directionality, Clarity, And Realism."
    },
    {
      title: "Dual Woofers",
      desc: "Cleaner, Punchier Bass With Lower Distortion Even At High Volumes. Feel The Powerful Low-End Without Sacrificing The Detail In Vocals, Guitars, And Drums."
    },
    {
      title: "Ultra-Comfort Ear Pads",
      desc: "Replaceable Ear Pads With Pressure-Distributing Foam For Long Listening Sessions."
    },
    {
      title: "50-Hour Battery Life",
      desc: "Power Through Playlists, Workdays, And Travel Without Reaching For A Charger. Listen For Days, Not Hours, On A Single Charge."
    },
    {
      title: "Wired And Wireless",
      desc: "Switch Seamlessly Between High-Fidelity Wired Listening And Wireless Freedom."
    },
    {
      title: "Custom Replaceable EarCup Covers",
      desc: "Celebrate Your Favorite Art And Music With Collectible SHELL Designs. Swap Shells To Fit Your Mood, Your Music, Or Your Style And Make HEAVYS Truly Yours."
    },
    {
      title: "HEAVYS Gaming Mode",
      desc: "Transform Your HEAVYS H1H Into A Premium Gaming Headset With The Included HeX Gaming Cable, Featuring True Zero-Latency Wired Audio, A Studio-Quality Boom Microphone, And Compatibility With PC, PlayStation, Xbox, Steam Deck, ROG Ally, Nintendo Switch, And More."
    }
  ];

  function initDesktop(section) {
    if (!section || section.getAttribute("data-gps-ready") === "1") return;
    var accordion = section.querySelector("[data-gps-accordion]");
    if (!accordion) return;
    section.setAttribute("data-gps-ready", "1");

    accordion.innerHTML = items
      .map(function (item, index) {
        var isActive = index === 0;
        return (
          '<div class="speaker-item ' + (isActive ? "active" : "") + '" data-index="' + index + '">' +
            '<button class="speaker-button" type="button" data-index="' + index + '">' +
              '<span class="speaker-number">' + (index + 1) + "</span>" +
              '<span class="speaker-title">' + item.title + "</span>" +
              '<span class="speaker-icon">' + (isActive ? "-" : "+") + "</span>" +
            "</button>" +
            '<div class="speaker-desc">' + item.desc + "</div>" +
          "</div>"
        );
      })
      .join("");

    function setActive(activeIndex) {
      section.querySelectorAll(".speaker-item").forEach(function (item, index) {
        var isActive = index === activeIndex;
        item.classList.toggle("active", isActive);
        var icon = item.querySelector(".speaker-icon");
        if (icon) icon.textContent = isActive ? "-" : "+";
      });
      section.querySelectorAll(".speaker-hotspot").forEach(function (hotspot, index) {
        hotspot.classList.toggle("active", index === activeIndex);
      });
    }

    section.addEventListener("click", function (event) {
      var trigger = event.target.closest && event.target.closest("[data-index]");
      if (!trigger || !section.contains(trigger)) return;
      var index = Number(trigger.getAttribute("data-index"));
      if (!Number.isNaN(index)) setActive(index);
    });
  }

  function initMobile(section) {
    if (!section || section.getAttribute("data-gps-ready") === "1") return;
    var mobileTrack = section.querySelector("[data-gps-mobile-track]");
    var mobileDots = section.querySelector("[data-gps-mobile-dots]");
    if (!mobileTrack) return;
    section.setAttribute("data-gps-ready", "1");

    var hotspots = section.querySelectorAll(".speaker-hotspot");

    mobileTrack.innerHTML = items
      .map(function (item, index) {
        var isActive = index === 0;
        return (
          '<article class="speaker-mobile-card ' + (isActive ? "active" : "") + '" data-index="' + index + '">' +
            '<div class="speaker-mobile-card-header">' +
              '<span class="speaker-mobile-number">' + (index + 1) + "</span>" +
              '<h3 class="speaker-mobile-title">' + item.title + "</h3>" +
            "</div>" +
            '<p class="speaker-mobile-desc">' + item.desc + "</p>" +
          "</article>"
        );
      })
      .join("");

    if (mobileDots) {
      mobileDots.innerHTML = items
        .map(function (_, index) {
          return (
            '<button class="speaker-mobile-dot ' + (index === 0 ? "active" : "") + '" type="button" data-index="' + index + '" aria-label="Show speaker feature ' + (index + 1) + '"></button>'
          );
        })
        .join("");
    }

    function scrollMobileCard(activeIndex) {
      var card = mobileTrack.querySelector('.speaker-mobile-card[data-index="' + activeIndex + '"]');
      if (!card) return;
      var trackPaddingLeft = parseFloat(window.getComputedStyle(mobileTrack).paddingLeft) || 0;
      mobileTrack.scrollTo({
        left: card.offsetLeft - trackPaddingLeft,
        behavior: "smooth"
      });
    }

    function setActive(activeIndex, shouldScrollMobile) {
      hotspots.forEach(function (hotspot, index) {
        hotspot.classList.toggle("active", index === activeIndex);
      });
      section.querySelectorAll(".speaker-mobile-card").forEach(function (card, index) {
        card.classList.toggle("active", index === activeIndex);
      });
      section.querySelectorAll(".speaker-mobile-dot").forEach(function (dot, index) {
        dot.classList.toggle("active", index === activeIndex);
      });
      if (shouldScrollMobile) scrollMobileCard(activeIndex);
    }

    section.addEventListener("click", function (event) {
      var trigger = event.target.closest("[data-index]");
      if (!trigger || !section.contains(trigger)) return;
      var index = Number(trigger.getAttribute("data-index"));
      if (!Number.isNaN(index)) setActive(index, true);
    });

    mobileTrack.addEventListener("scroll", function () {
      window.requestAnimationFrame(function () {
        var cards = Array.from(mobileTrack.querySelectorAll(".speaker-mobile-card"));
        var trackPaddingLeft = parseFloat(window.getComputedStyle(mobileTrack).paddingLeft) || 0;
        var activeCard = cards.reduce(function (closest, card) {
          var distance = Math.abs(card.offsetLeft - mobileTrack.scrollLeft - trackPaddingLeft);
          if (!closest || distance < closest.distance) return { card: card, distance: distance };
          return closest;
        }, null);
        if (!activeCard) return;
        var index = Number(activeCard.card.getAttribute("data-index"));
        if (!Number.isNaN(index)) setActive(index, false);
      });
    });
  }

  function boot() {
    document.querySelectorAll("[data-gps-desktop]").forEach(initDesktop);
    document.querySelectorAll("[data-gps-mobile]").forEach(initMobile);
  }

  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);

  document.addEventListener("shopify:section:load", boot);
})();
